/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ReportingPresetProvider } from 'src/app/providers';
import { ReportingPreset } from 'src/app/model';

@Component({
  selector: 'app-manage-preset-modal',
  templateUrl: './manage-preset.modal.html',
  styleUrls: ['./manage-preset.modal.scss']
})

export class ManagePresetModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;
  presets: ReportingPreset[] = [];
  totalItems = 0;
  currentPage = 1;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private reportingPresetProvider: ReportingPresetProvider
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });

    this.reportingPresetProvider.getPresets(1).subscribe(data => {
      this.presets = ReportingPreset.parseArray(data.result.items);
      this.totalItems = data.result.totalItems;
    });
  }

  ngOnDestroy(): void {

  }

  onSubmit(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }
  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

  removePreset(preset: ReportingPreset, index: number): void {
    this.reportingPresetProvider.deletePreset(preset.ID)
      .subscribe(data => {
        if (data.success) {
          this.presets.splice(index, 1);
          this.bsModalRef.hide();
          this.subject.next(true);
          this.subject.complete();
        }
      });
  }
}
